// ** React Imports
import { useCallback, useContext, useMemo, useState } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiperNew/react";
import { Autoplay } from "swiperNew/modules";

// ** Swiper styles
import "swiperNew/css";
import "swiperNew/css/pagination";

// ** Custom Components
import Img from "components/base/Img";
import Block from "components/layout/Block";
import SliderPaginationAlwaysMiddle from "containers/Modal/components/Swipers/SliderPaginationAlwaysMiddle";
import { StyledOverlay } from "styles/components/Overlay.styled";

// ** Utils & Helpers
import staticFileHelper from "helpers/staticFileHelper";

// ** Contexts
import DeviceTypeContext from "contexts/deviceTypeContext";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

const ImgWelcomeScreenshot = styled(Img)`
	width: 100%;
	max-width: 600px;
	height: auto;

	@media (max-width: ${breakpoints.phone - 1}px) {
		width: 100%;
		max-width: 300px;
		height: auto;
	}
`;

const StyledBlock = styled(Block)`
	border: 3px solid var(--dz-sys-text-color);
`;

const StyledBlockContainer = styled(Block)`
	width: 100%;
	max-width: 600px;
	padding-right: 2rem;

	@media (max-width: ${breakpoints.phone - 1}px) {
		width: 90%;
		margin: 0 auto;
		padding-right: 0;
		max-width: 300px;
	}
`;

const SLIDES_NAMES = ["start", "users", "profil", "messages", "modal"];
// #####################################################

const WelcomeSlider = () => {
	const { isDesktop, isPhone } = useContext(DeviceTypeContext);

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);
	const language = useSelector((state) => state.globalCommon.language);

	const [welcomeSwiper, setWelcomeSwiper] = useState(null);
	const [activeSlide, setActiveSlide] = useState(0);

	const slides = useMemo(() => {
		return SLIDES_NAMES.map((slideName) =>
			staticFileHelper(
				`/img/layout/main/${isPhone ? "mobile" : "desktop"}/${
					isDarkMode ? "dark" : "light"
				}/${language}/${slideName}.jpg`,
				"screens"
			)
		);
	}, [isPhone, language, isDarkMode, isDesktop]);

	const renderSlides = useCallback(() => {
		return slides.map((link) => (
			<SwiperSlide key={link}>
				<StyledOverlay style={{ zIndex: 3 }} />
				<ImgWelcomeScreenshot
					src={link}
					width={isPhone ? 360 : 600}
					height={isPhone ? 800 : 360}
					loading="lazy"
				/>
			</SwiperSlide>
		));
	}, [slides, isDarkMode]);

	const handleClickPagination = (index) => {
		welcomeSwiper.slideTo(index);
	};

	// #####################################################

	return (
		<StyledBlockContainer>
			<StyledBlock mb={5}>
				<Swiper
					slidesPerView={1}
					spaceBetween={5}
					modules={[Autoplay]}
					loop
					onSwiper={(swiper) => {
						setWelcomeSwiper(swiper);
					}}
					onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
					autoplay={{
						delay: 2500,
						disableOnInteraction: true,
					}}
				>
					{renderSlides()}
				</Swiper>
			</StyledBlock>
			<SliderPaginationAlwaysMiddle
				activeSlide={activeSlide}
				swiper={welcomeSwiper}
				isWelcomeSlider
			/>
		</StyledBlockContainer>
	);
};

// #####################################################

export default WelcomeSlider;

// #####################################################
